export enum AiAssistantLabelEnum {
  BadConversation = 'Zła rozmowa',
  Close = 'Zamknij czat',
  ConnectionError = 'Błąd połączenia z Asystentem wiedzy',
  ConnectionFailed = 'Nie udało się połączyć z Asystentem wiedzy',
  ConversationArchived = 'Rozmowa zarchiwizowana. Utwórz nową rozmowę, aby zadać kolejne pytanie.',
  Description = 'Pomoc podczas obsługi klienta',
  EnlargeWindow = 'Powiększ okno',
  FeedbackThanks = 'Dzięki za informację',
  GoodConversation = 'Dobra rozmowa',
  InputPlaceholder = 'Zadaj pytanie...',
  LessCategories = 'Mniej',
  MessageInputLabel = 'Twoje pytanie',
  MessagesLabel = 'Rozmowa z Asystentem wiedzy',
  MoreCategories = 'Więcej',
  NewConversation = 'Nowa rozmowa',
  RateConversation = 'Jak oceniasz tę rozmowę?',
  ResponseInterrupted = 'Odpowiedź przerwana',
  RestoreWindowSize = 'Przywróć rozmiar okna',
  ScrollToEnd = 'Przewiń na dół',
  Send = 'Wyślij',
  ShowDescription = 'Pokaż opis',
  StopResponse = 'Zatrzymaj odpowiedź',
  Title = 'Asystent wiedzy',
  Typing = 'Asystent wiedzy pisze…',
  Welcome = 'Zadaj pytanie na podstawie Szybkiej ściągi. Możesz również zapytać o sprawy związane z danym klientem, np. bonus. Użyj przycisków poniżej lub zadaj własne pytanie.',
}
